export default "__VITE_ASSET__BIrr9TeS__"